// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"e07aa031","213":"202929bd","453":"aa32f34e"}[chunkId] + ".chunk.js";
};